import Mapir from "mapir-react-component";
import 'mapbox-gl/dist/mapbox-gl.css';

export const Map = Mapir.setToken({
    transformRequest: url => {
        return {
            url: url, headers: {
                "x-api-key": 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjllMmFiMjE4MjEzMjI4YmIyMTM5OWFlNjgyNTRkN2Y3NThmYWU3NGRmZGQ2NjViN2RhZGVmMWIxOWFhODg0YTMzMDVlZGUxOWUyOTVjYTEyIn0.eyJhdWQiOiIyNDM2NiIsImp0aSI6IjllMmFiMjE4MjEzMjI4YmIyMTM5OWFlNjgyNTRkN2Y3NThmYWU3NGRmZGQ2NjViN2RhZGVmMWIxOWFhODg0YTMzMDVlZGUxOWUyOTVjYTEyIiwiaWF0IjoxNjk2MzcyNTkyLCJuYmYiOjE2OTYzNzI1OTIsImV4cCI6MTY5ODg3ODE5Miwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oEE6bnb9YLzTdsh0w_oMXY6trPg3FWm1pN1OfGfnbNAWsu3ODkyI3pfHFDfZAPJ2NHhixT7UKxeYYB-9YOmJIutiywx1CUZHdABaNv733Y1R0q-9Sx-tywHjFus5PcUgLqH4LMLMQvzduLxpVV44eJh29AKzLYBACsnUCFygxfh1zti5u7VdnKhmBMf8t6_tfSVzaUIaf0uBLeyQwJH56K7nyzHzY0wsIr3zZ8f7PXJt4vvJ74dbW05rDwVjBkXoT4EpwsCH6udlt1_nTQVER-hr8IPxs1KFHl4IG63SamYKzFROo48MMCcQT17paPgSa-P-gDeI6Amr3CvZP5_0SA', //Mapir api key
                "Mapir-SDK": "reactjs"
            }
        };
    }
});